var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (fieldsetCounter, globals, id) {
      pug_mixins["back"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Ca href=\"{{path}}\"\u003E\u003Ci class=\"font-icon icon-arrow-left\"\u003E\u003C\u002Fi\u003E\u003Cspan\u003Ezurück\u003C\u002Fspan\u003E\u003C\u002Fa\u003E";
};
pug_mixins["intro"] = pug_interp = function(data){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!data) { data={is_bonus: false}; }
if (data.process === 'NEO') {
pug_html = pug_html + "\u003Cdiv class=\"wizardbox centered\" ng-class=\"{highlighted: &quot;intro&quot; == component.box.step}\"\u003E\u003Cdiv class=\"header\" ng-class=\"{show: &quot;intro&quot; == component.box.step }\"\u003E\u003Ca ng-click=\"component.toggleStep(&quot;intro&quot;)\"\u003E\u003Cspan class=\"step\"\u003E1\u003C\u002Fspan\u003E\u003Cspan class=\"title\"\u003E" + (pug.escape(null == (pug_interp = data.title || 'So funktioniert´s') ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\" ng-if=\"&quot;intro&quot; == component.box.step\"\u003E\u003Cdiv class=\"mainWrapper\"\u003E\u003Cdiv class=\"step1\"\u003E";
if (data.video) {
pug_html = pug_html + "\u003Cdiv class=\"video-wrap\"\u003E\u003Ciframe" + (pug.attr("src", data.video, true, true)+pug.attr("webkitallowfullscreen", true, true, true)+pug.attr("mozallowfullscreen", true, true, true)+pug.attr("allowfullscreen", true, true, true)) + "\u003E\u003C\u002Fiframe\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cspan class=\"subtitle\"\u003E" + (pug.escape(null == (pug_interp = data.subtitle) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan class=\"subsubtitle\"\u003E" + (pug.escape(null == (pug_interp = data.subsubtitle) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan class=\"description\"\u003E" + (pug.escape(null == (pug_interp = data.description) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cbr\u003E\u003Cp class=\"error\" ng-show=\"component.is_already_used\"\u003ESie nutzen bereits diesen Baustein!\u003C\u002Fp\u003E\u003Ca class=\"button button-primary float-right\" ng-click=\"component.toggleStep(&quot;values&quot;)\" ng-if=\"!component.is_pc\" data-cy=\"neo.preCheckout.basicComponent.wizardBegin.buttonNext\"\u003EWeiter\u003C\u002Fa\u003E\u003Ca class=\"button button-primary right\" ng-click=\"component.goToMPP()\" ng-if=\"component.is_pc\" data-cy=\"neo.preCheckout.pcLeasing.wizardBegin.buttonNext\"\u003EWeiter\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
if (data.process === 'BONUS') {
pug_html = pug_html + "\u003Cdiv class=\"wizardbox centered\"\u003E\u003Cdiv class=\"header\"\u003E\u003Ca\u003E\u003Cspan class=\"step\"\u003E1\u003C\u002Fspan\u003E\u003Cspan class=\"title\"\u003E" + (pug.escape(null == (pug_interp = data.title || 'So funktioniert´s') ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\"\u003E\u003Cdiv class=\"mainWrapper\"\u003E\u003Cdiv class=\"step1\"\u003E";
if (data.video) {
pug_html = pug_html + "\u003Cdiv class=\"video-wrap\"\u003E\u003Ciframe" + (pug.attr("src", data.video, true, true)+pug.attr("webkitallowfullscreen", true, true, true)+pug.attr("mozallowfullscreen", true, true, true)+pug.attr("allowfullscreen", true, true, true)) + "\u003E\u003C\u002Fiframe\u003E\u003C\u002Fdiv\u003E";
}
if (data.image) {
pug_html = pug_html + "\u003Cdiv class=\"baustein\"\u003E\u003Cdiv class=\"bausteinContainer\"\u003E\u003Ca" + (" class=\"imgWrapper\""+pug.attr("ng-href", '/module/' + data.image, true, true)) + "\u003E\u003Cdiv" + (" class=\"imgContainer\""+pug.attr("style", pug.style('background-image: url(/assets/img/bonus/' + data.image + '.jpg)'), true, true)) + "\u003E\u003C\u002Fdiv\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cspan class=\"subtitle\"\u003E" + (pug.escape(null == (pug_interp = data.subtitle) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan class=\"subsubtitle\"\u003E" + (pug.escape(null == (pug_interp = data.subsubtitle) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan class=\"subsubtitle\"\u003E" + (pug.escape(null == (pug_interp = data.subsubtitle2) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cbr\u003E";
block && block();
pug_html = pug_html + "\u003Cbr\u003E\u003Cdiv class=\"row\" ng-if=\"component.isBonusCancelled() || !component.isProjectApproved()\"\u003E\u003Cp class=\"red\"\u003EDer Checkout ist leider nicht möglich.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"!component.hasSachbezugCheckouts &amp;&amp; component.all_active_checkouts.length &gt; 0\"\u003E\u003Cspan class=\"red\"\u003ESie nutzen bereits diese Wahlleistung für den Zeitraum\u003C\u002Fspan\u003E\u003Cspan ng-repeat=\"bonus_checkout in component.all_active_checkouts\"\u003E{{ component.getComponentDisplayStartDate(bonus_checkout) | date }} bis {{ component.getComponentDisplayEndDate(bonus_checkout) | date }} mit einem monatlichen Betrag von {{ bonus_checkout.checkout_config.per_month_value | currency : 'EUR' }}.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cspan class=\"red\" ng-if=\"component.hasSachbezugCheckouts\"\u003ESie nutzen bereits diese Wahlleistung für den Zeitraum\u003C\u002Fspan\u003E\u003Cbr\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"component.allSachbezugCheckouts['sachbezug'] &amp;&amp; component.allSachbezugCheckouts['sachbezug'].length &gt; 0\"\u003E\u003Cspan class=\"red\"\u003ESACHBEZUG | VORTEILSKONTO\u003C\u002Fspan\u003E\u003Cspan ng-repeat=\"bonus_checkout in component.allSachbezugCheckouts['sachbezug']\"\u003E{{ component.getComponentDisplayStartDate(bonus_checkout) | date }} bis {{ component.getComponentDisplayEndDate(bonus_checkout) | date }} mit einem monatlichen Betrag von {{ bonus_checkout.checkout_config.per_month_value | currency : 'EUR' }}.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"component.allSachbezugCheckouts['sachbezug_pluxee'] &amp;&amp; component.allSachbezugCheckouts['sachbezug_pluxee'].length &gt; 0\"\u003E\u003Cspan class=\"red\"\u003ESACHBEZUG | BENEFITS CARD\u003C\u002Fspan\u003E\u003Cspan ng-repeat=\"bonus_checkout in component.allSachbezugCheckouts['sachbezug_pluxee']\"\u003E{{ component.getComponentDisplayStartDate(bonus_checkout) | date }} bis {{ component.getComponentDisplayEndDate(bonus_checkout) | date }} mit einem monatlichen Betrag von {{ bonus_checkout.checkout_config.per_month_value | currency : 'EUR' }}.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"component.allSachbezugCheckouts['sachbezug_profit'] &amp;&amp; component.allSachbezugCheckouts['sachbezug_profit'].length &gt; 0\"\u003E\u003Cspan class=\"red\"\u003ESACHBEZUG | FITNESSKONTO\u003C\u002Fspan\u003E\u003Cspan ng-repeat=\"bonus_checkout in component.allSachbezugCheckouts['sachbezug_profit']\"\u003E{{ component.getComponentDisplayStartDate(bonus_checkout) | date }} bis {{ component.getComponentDisplayEndDate(bonus_checkout) | date }} mit einem monatlichen Betrag von {{ bonus_checkout.checkout_config.per_month_value | currency : 'EUR' }}.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003Cdiv class=\"row\" ng-if=\"!component.isBonusDefaultStartDateCheckoutAvailable &amp;&amp; !component.is_component_cashback\"\u003E\u003Cp class=\"red\"\u003EDiese Wahlleistung steht in diesem Projekt aktuell nicht zur Verfügung.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"(component.is_component_cashback &amp;&amp; !component.is_cashback_request_available) || !component.isDecisionDateValid()\"\u003E\u003Cp class=\"red\"\u003EDer Zeitraum zur Beantragung dieser Wahlleistung ist abgelaufen.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row red\" ng-if=\"component.isPcBlocked\"\u003E\u003Cp class=\"red\"\u003EDie Wahlleistung PC Leasing ist leider gesperrt.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row red\" ng-if=\"component.disableCheckoutIfMultipleSachbezugCheckouts\"\u003E\u003Cbr\u003E\u003Cp class=\"red\"\u003ESie beantragen bereits die Wahlleistung - {{ component.sachbezugCheckedoutComponent }}. Bitte schließen Sie zuerst diese Beantragung ab.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003Cbutton class=\"button button-primary float-left\" ng-click=\"component.navigateBackToDashboard()\" data-cy=\"bonus.preCheckout.basicComponent.wizardBegin.buttonPrevious\"\u003Ezurück zur Übersicht\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-primary float-right\" ng-click=\"component.addComponentToEmployeeBonusComponents()\" ng-if=\"component.isDecisionDateValid() &amp;&amp; !component.is_component_cashback &amp;&amp; component.canContinue()\" data-cy=\"bonus.preCheckout.basicComponent.wizardBegin.buttonNext\"\u003E" + (pug.escape(null == (pug_interp = data.label_next_button || 'Weiter') ? "" : pug_interp)) + "\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-primary float-right\" ng-click=\"component.continueToCashbackRequestStep()\" ng-if=\"component.isDecisionDateValid() &amp;&amp; component.is_component_cashback &amp;&amp; component.is_cashback_request_available\" data-cy=\"bonus.preCheckout.basicComponent.wizardBegin.buttonNext\"\u003E" + (pug.escape(null == (pug_interp = data.label_next_button || 'Weiter') ? "" : pug_interp)) + "\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
if (data.process === 'NEO_COMPONENT') {
pug_html = pug_html + "\u003Cdiv class=\"wizardbox centered\" overlay=\"!$ctrl.isLoaded\"\u003E\u003Cdiv class=\"header\"\u003E\u003Ca\u003E\u003Cspan class=\"step\"\u003E1\u003C\u002Fspan\u003E\u003Cspan class=\"title\"\u003E" + (pug.escape(null == (pug_interp = data.title || 'So funktioniert´s {{ $ctrl.neo_component.title }}') ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\"\u003E\u003Cdiv class=\"mainWrapper\"\u003E\u003Cdiv class=\"step1\"\u003E";
if (data.video) {
pug_html = pug_html + "\u003Cdiv class=\"video-wrap\"\u003E\u003Ciframe" + (pug.attr("src", data.video, true, true)+pug.attr("webkitallowfullscreen", true, true, true)+pug.attr("mozallowfullscreen", true, true, true)+pug.attr("allowfullscreen", true, true, true)) + "\u003E\u003C\u002Fiframe\u003E\u003C\u002Fdiv\u003E";
}
if (data.image) {
pug_html = pug_html + "\u003Cdiv class=\"baustein\"\u003E\u003Cdiv class=\"bausteinContainer\"\u003E\u003Ca" + (" class=\"imgWrapper\""+pug.attr("ng-href", '/module/' + data.image, true, true)) + "\u003E\u003Cdiv" + (" class=\"imgContainer\""+pug.attr("style", pug.style('background-image: url(/assets/img/bonus/' + data.image + '.jpg)'), true, true)) + "\u003E\u003C\u002Fdiv\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cspan class=\"subtitle\"\u003E" + (pug.escape(null == (pug_interp = data.subtitle) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan class=\"subsubtitle\"\u003E" + (pug.escape(null == (pug_interp = data.subsubtitle) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan class=\"subsubtitle\"\u003E" + (pug.escape(null == (pug_interp = data.subsubtitle2) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cbr\u003E";
block && block();
pug_html = pug_html + "\u003Cp class=\"red\" ng-if=\"$ctrl.isBlockedForPcLeasing\"\u003EDie Wahlleistung PC Leasing ist leider gesperrt.\u003C\u002Fp\u003E\u003Cbr\u003E\u003Cbutton class=\"button button-primary float-left\" ng-click=\"$ctrl.navigateBackToDashboard()\" data-cy=\"neo.preCheckout.basicComponent.wizardBegin.buttonPrevious\"\u003Ezurück zur Übersicht\u003C\u002Fbutton\u003E\u003Cspan class=\"right\" ng-if=\"$ctrl.isLoaded\"\u003E\u003Cbutton class=\"button button-primary float-right\" ng-click=\"$ctrl.enterStepTwo()\" ng-if=\"$ctrl.canEnterStepTwo() &amp;&amp; $ctrl.doesUserHasSalary\" data-cy=\"neo.preCheckout.basicComponent.wizardBegin.buttonNext\"\u003E" + (pug.escape(null == (pug_interp = data.label_next_button || 'Weiter') ? "" : pug_interp)) + "\u003C\u002Fbutton\u003E\u003Cdiv class=\"float-right\" ng-if=\"!$ctrl.canEnterStepTwo()\"\u003E\u003Cp class=\"error\"\u003EDer Abruf von PC-Leasing ist akuell nicht möglich.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"float-right\" ng-if=\"!$ctrl.doesUserHasSalary\"\u003E\u003Cp class=\"error\"\u003EEine Beantragung ist aufgrund fehlender Einstellungen aktuell nicht möglich.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
};
pug_mixins["values"] = pug_interp = function(data){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!data) { data={is_bonus: false}; }
if (data.process === 'NEO') {
pug_html = pug_html + "\u003Cdiv class=\"wizardbox centered\" ng-class=\"{highlighted: &quot;values&quot; == component.box.step}\"\u003E\u003Cdiv class=\"header\" ng-class=\"{show: &quot;values&quot; == component.box.step }\"\u003E\u003Ca ng-click=\"component.toggleStep(&quot;values&quot;)\"\u003E\u003Cspan class=\"step\"\u003E2\u003C\u002Fspan\u003E\u003Cspan class=\"title\"\u003E" + (pug.escape(null == (pug_interp = data.title || '') ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\" ng-if=\"&quot;values&quot; == component.box.step\"\u003E\u003Cdiv class=\"mainWrapper\"\u003E\u003Cdiv class=\"step2\"\u003E";
block && block();
pug_html = pug_html + "\u003Cdiv class=\"clearfix\"\u003E\u003C\u002Fdiv\u003E";
if (data.description) {
pug_html = pug_html + "\u003Cspan class=\"description\"\u003E" + (pug.escape(null == (pug_interp = data.description) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003Cbr\u003E\u003Cbr\u003E\u003Ca class=\"button button-primary right\" ng-disabled=\"!component.canExitValuesScreen()\" ng-click=\"component.toggleStep(&quot;checkout&quot;)\" data-cy=\"neo.preCheckout.basicComponent.wizardConfig.buttonNext\"\u003EWeiter\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
if (data.process === 'BONUS') {
pug_html = pug_html + "\u003Cdiv class=\"wizardbox centered\"\u003E\u003Cdiv class=\"header\"\u003E\u003Ca\u003E\u003Cspan class=\"step\"\u003E2\u003C\u002Fspan\u003E\u003Cspan class=\"title\"\u003E" + (pug.escape(null == (pug_interp = data.title || '') ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\"\u003E\u003Cdiv class=\"mainWrapper\"\u003E\u003Cdiv class=\"step2 flex-column\"\u003E";
block && block();
pug_html = pug_html + "\u003Cdiv class=\"clearfix\"\u003E\u003C\u002Fdiv\u003E";
if (data.description) {
pug_html = pug_html + "\u003Cspan class=\"description\"\u003E" + (pug.escape(null == (pug_interp = data.description) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003Cbr\u003E\u003Cbr\u003E\u003Cdiv\u003E\u003Cbutton class=\"button button-primary left\" wz-cancel data-cy=\"bonus.preCheckout.basicComponent.wizardConfig.buttonCancel\"\u003Ezurück zur Übersicht\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-primary right\" wz-next ng-disabled=\"!component.toAllowComponentAddition()\" ng-if=\"component.step2SelectionPossible()\" ng-click=\"component.stepValuesHandler &amp;&amp; component.stepValuesHandler()\" data-cy=\"bonus.preCheckout.basicComponent.wizardConfig.buttonConfirm\"\u003E" + (pug.escape(null == (pug_interp = data.step2ButtonTitle || 'Auswahl übernehmen') ? "" : pug_interp)) + "\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
if (data.process === 'NEO_COMPONENT') {
pug_html = pug_html + "\u003Cdiv class=\"wizardbox centered\"\u003E\u003Cdiv class=\"header\"\u003E\u003Ca\u003E\u003Cspan class=\"step\"\u003E2\u003C\u002Fspan\u003E\u003Cspan class=\"title\"\u003E" + (pug.escape(null == (pug_interp = data.title || '') ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\"\u003E\u003Cdiv class=\"mainWrapper\"\u003E\u003Cdiv class=\"step2 flex-column\"\u003E";
block && block();
pug_html = pug_html + "\u003Cdiv class=\"clearfix\"\u003E\u003C\u002Fdiv\u003E";
if (data.description) {
pug_html = pug_html + "\u003Cspan class=\"description\"\u003E" + (pug.escape(null == (pug_interp = data.description) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003Cbr\u003E\u003Cbr\u003E\u003Cdiv\u003E\u003Cbutton class=\"button button-primary left\" wz-cancel\u003Ezurück zur Übersicht\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-primary right\" wz-next ng-disabled=\"!$ctrl.toAllowComponentAddition()\" ng-if=\"$ctrl.step2SelectionPossible()\" data-cy=\"neo.preCheckout.basicComponent.wizardConfig.buttonNext\"\u003EAuswahl übernehmen\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
};





pug_mixins["checkout"] = pug_interp = function(data){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!data) { data={}; }
pug_html = pug_html + "\u003Cdiv class=\"wizardbox centered\" ng-class=\"{highlighted: &quot;checkout&quot; == component.box.step}\"\u003E\u003Cdiv class=\"header\" ng-class=\"{show: &quot;checkout&quot; == component.box.step }\"\u003E\u003Ca ng-click=\"component.toggleStep(&quot;checkout&quot;)\"\u003E\u003Cspan class=\"step\"\u003E3\u003C\u002Fspan\u003E\u003Cspan class=\"title\"\u003E" + (pug.escape(null == (pug_interp = data.title || 'Zusammenfassung') ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\" ng-if=\"&quot;checkout&quot; == component.box.step\"\u003E\u003Cdiv class=\"mainWrapper\"\u003E\u003Cdiv class=\"step2\"\u003E";
if ((data.video)) {
pug_html = pug_html + "\u003Cdiv class=\"video-wrap\"\u003E\u003Ciframe src=\"https:\u002F\u002Fplayer.vimeo.com\u002Fvideo\u002F397982616?dnt=1\" webkitallowfullscreen mozallowfullscreen allowfullscreen\u003E\u003C\u002Fiframe\u003E\u003C\u002Fdiv\u003E";
}
if ((data.image)) {
pug_html = pug_html + "\u003Cdiv class=\"video-wrap\"\u003E\u003Ciframe" + (pug.attr("src", data.image, true, true)+pug.attr("webkitallowfullscreen", true, true, true)+pug.attr("mozallowfullscreen", true, true, true)+pug.attr("allowfullscreen", true, true, true)) + "\u003E\u003C\u002Fiframe\u003E\u003C\u002Fdiv\u003E";
}
if ((data.description == 'bikeleasing')) {
pug_html = pug_html + "\u003Cp class=\"description\"\u003E\u003Cspan\u003ESie möchten wissen wie es weitergeht?\u003C\u002Fspan\u003E\u003Cbr\u003E\u003Cspan\u003EWenn Sie beim Händler Ihr Wunschfahrrad ausgesucht haben, benötigt dieser ein paar Informationen von Ihnen.\u003C\u002Fspan\u003E\u003Cbr\u003E\u003Cbr\u003E\u003Cspan\u003E\u003Cstrong\u003EE-Mail Adresse:\u003C\u002Fstrong\u003E\u003C\u002Fspan\u003E\u003Cbr\u003E\u003Cspan\u003EMit Ihrer E-Mail Adresse registriert er Sie im Bikeleasingportal, damit Sie später auch auf Ihren Vertrag Zugriff haben und im Falle eines Schadens schnell reagieren können.\u003C\u002Fspan\u003E\u003Cbr\u003E\u003Cspan\u003EBitte geben Sie beim Händler Ihre Login-Adresse als E-Mail-Adresse an, nur so können wir eine schnelle Bearbeitung und Zuordnung sicherstellen.\u003C\u002Fspan\u003E\u003Cbr\u003E\u003Cbr\u003E\u003Cspan\u003E\u003Cstrong\u003EValueNetID:\u003C\u002Fstrong\u003E\u003C\u002Fspan\u003E\u003Cbr\u003E\u003Cspan\u003EDie ValueNetID ist Ihre persönliche Kennung. Die Nummer finden Sie oben rechts neben Ihrem Namen. Beim Händler wird diese als Personalnummer\u002FValueNetID angegeben.\u003C\u002Fspan\u003E\u003Cbr\u003E\u003Cbr\u003E\u003Cspan\u003E\u003Cstrong\u003EBikeleasing Firmen Code:\u003C\u002Fstrong\u003E\u003C\u002Fspan\u003E\u003Cbr\u003E\u003Cspan ng-if=\"component.neoConfig.bike.agCode &amp;&amp; !(component.neoConfig.bike.agCode === &quot;0000&quot;)\"\u003E{{ component.neoConfig.bike.agCode }}\u003C\u002Fspan\u003E\u003Cspan ng-if=\"component.neoConfig.bike.agCode &amp;&amp; component.neoConfig.bike.agCode === &quot;0000&quot;\"\u003EBitte informieren Sie sich auf dem Schwarzen Brett hier im Portal über den für Sie gültigen Firmen Code.\u003C\u002Fspan\u003E\u003Cspan ng-if=\"!component.neoConfig.bike.agCode\"\u003E... folgt...\u003C\u002Fspan\u003E\u003Cbr\u003E\u003Cspan\u003EMit diesem 4-stelligen Code weisen Sie sich als berechtigter Arbeitnehmer aus.\u003C\u002Fspan\u003E\u003Cbr\u003E\u003Ca href=\"https:\u002F\u002Fbikeleasing.de\u002Fhaendler-finden#c2154\" target=\"_blank\"\u003EBikeleasing-Händler finden\u003C\u002Fa\u003E\u003Cbr\u003E\u003C\u002Fp\u003E";
}
else {
pug_html = pug_html + "\u003Cspan class=\"description\"\u003E" + (pug.escape(null == (pug_interp = data.description || '') ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003Cbr\u003E\u003Cbr\u003E\u003Cdiv class=\"button-wrapper\"\u003E\u003Cinner-html ng-if=\"component.salaryError\" bind-html-compile=\"component.salaryError\"\u003E\u003C\u002Finner-html\u003E\u003Ca class=\"button left\" href=\"{{path}}\" data-cy=\"neo.preCheckout.basicComponent.wizardEnd.buttonAddComponents\"\u003EWeitere Bausteine\u003C\u002Fa\u003E\u003Cbutton class=\"button right\" ui-sref=\"inApp.neo.side.checkout.zusammenfassung\" ng-if=\"!component.infomode &amp;&amp; !component.noSelfCheckout &amp;&amp; component.vbmData.employees[employeeId].data.parameters.einsparungs_modell == &quot;NONE&quot; &amp;&amp; component.moduleId != &quot;Bikeleasing&quot;\" ng-disabled=\"!(component.vbmData.hasComponents() || component.vbmData.hasBAV()) || component.disableCheckoutIfNoSalary || component.salaryLoading\" data-cy=\"neo.preCheckout.basicComponents.wizardEnd.buttonStartCheckout\"\u003EZur Beantragung\u003C\u002Fbutton\u003E\u003Cbutton class=\"button right\" ng-if=\"component.moduleId == &quot;Bikeleasing&quot;\" ng-disabled=\"\" ng-click=\"component.downloadBikeleasingDocument()\"\u003EDokument herunterladen\u003C\u002Fbutton\u003E\u003Cbutton class=\"button right\" ng-click=\"component.contact()\" ng-if=\"component.infomode &amp;&amp; !component.noSelfCheckout &amp;&amp; component.vbmData.employees[employeeId].data.parameters.einsparungs_modell == &quot;NONE&quot;\" ng-disabled=\"!(component.vbmData.hasComponents() || component.vbmData.hasBAV()) || component.disableCheckoutIfNoSalary || component.salaryLoading\" data-cy=\"neo.infoCheckout.basicComponents.wizardEnd.buttonStartCheckout\"\u003EZur Beantragung\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};







































































































pug_mixins["checkbox"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key
}
if (!attributes.attributes) {
attributes.attributes = {}
}
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": "checkbox schema-form-checkbox"},attributes.groupAttributes]), true)) + "\u003E\u003Cinput" + (pug.attrs(pug.merge([{"class": pug.classes([attributes.fieldHtmlClass], [true]),"type": "checkbox","ng-model": pug.escape(attributes.key),"ng-disabled": pug.escape(attributes.readonly),"id": pug.escape(id),"name": pug.escape(id),"required": pug.escape(attributes.required),"ng-true-value": pug.escape(attributes['ng-true-value']),"ng-false-value": pug.escape(attributes['ng-false-value']),"data-cy": pug.escape(attributes['data-cy'])},attributes.attributes]), true)) + "\u003E\u003Clabel" + (pug.attr("class", pug.classes([attributes.labelHtmlClass], [true]), false, true)+pug.attr("for", id, true, true)) + "\u003E\u003Cspan\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E";
};




















































pug_mixins["radio"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.title && attributes.name) {
attributes.title = attributes.name
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key + '-' + attributes.index
}
pug_html = pug_html + "\u003Cinput" + (pug.attr("class", pug.classes([attributes.fieldHtmlClass], [true]), false, true)+pug.attr("id", id, true, true)+" type=\"radio\""+pug.attr("required", attributes.required, true, true)+pug.attr("name", attributes.key, true, true)+pug.attr("ng-model", attributes.key, true, true)+pug.attr("ng-disabled", attributes.readonly, true, true)+pug.attr("value", attributes.value, true, true)+pug.attr("ng-value", attributes['ng-value'], true, true)+pug.attr("data-cy", attributes['data-cy'], true, true)+pug.attr("ng-change", attributes['ng-change'], true, true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (" class=\"radio-inline\""+pug.attr("for", attributes.key + '-' + attributes.index, true, true)) + "\u003E\u003Cspan\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E";
}
};






































































pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (!fieldsetCounter) {
fieldsetCounter = 0
}





















pug_mixins["back"]();
pug_mixins["intro"]({
  process: 'NEO',
  video:       'https://player.vimeo.com/video/397980824?dnt=1',
  subtitle:    'Werbung die sich lohnt',
  subsubtitle: 'Wenn Sie einen PKW besitzen, können Sie Kennzeichenhalterungen mit einem Werbeauftritt an Ihrem PKW anbringen und erhalten steuerfrei monatlich 21 €.'
});
pug_mixins["values"].call({
block: function(){
pug_html = pug_html + " ";
pug_mixins["checkbox"].call({
attributes: {"key": "component.model.value","title": "Ich stelle die Werbefäche an meinem privaten PKW für 21 &amp;euro; im Monat zur Verfügung","ng-true-value": "21","ng-false-value": "0"}
});
pug_html = pug_html + "\u003Cspan style=\"display:none\" ng-init=\"component.model.enabled = true\"\u003E\u003C\u002Fspan\u003E";
}
}, {
  process: 'NEO',
  title:       'Die Nummernschildhalterung als Werbefläche',
  description: 'Bringen Sie eine Nummernschildhalterung an Ihr privates Auto an.'
});
pug_mixins["checkout"]({
  description: 'Wenn Sie diesen Baustein nutzen, werden wir Ihnen eine Nummernschildhalterung zur Verfügung stellen, bitte bringen Sie diese an ihrem PKW an. Sie können nun weitere Bausteine hinzufügen oder die Bausteinwahl abschließen.',
  video: true
});
    }.call(this, "fieldsetCounter" in locals_for_with ?
        locals_for_with.fieldsetCounter :
        typeof fieldsetCounter !== 'undefined' ? fieldsetCounter : undefined, "globals" in locals_for_with ?
        locals_for_with.globals :
        typeof globals !== 'undefined' ? globals : undefined, "id" in locals_for_with ?
        locals_for_with.id :
        typeof id !== 'undefined' ? id : undefined));
    ;;return pug_html;};
module.exports = template;